import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getStatusSales() {
	return client.get("api/dashboard/status-sales", {
	});
}

function getTotalSales() {
	return client.get("api/dashboard/total-sales", {
	});
}

function getTotalPurchase() {
	return client.get("api/dashboard/total-purchase", {
	});
}

function getSalesProduct() {
	return client.get("api/dashboard/sales", {
	});
}

function getSalesProductWeekly(params) {
	return client.get("api/dashboard/sales-weekly", {
		params: params,
	});
}

function getSalesPriceWeekly(params) {
	return client.get("api/dashboard/sales-price-weekly", {
		params: params,
	});
}

function getSalesRetailWeekly(params) {
	return client.get("api/dashboard/sales-retail-weekly", {
		params: params,
	});
}

function getSalesRetailPriceWeekly(params) {
	return client.get("api/dashboard/sales-retail-price-weekly", {
		params: params,
	});
}

function getResumeStock() {
	return client.get("api/dashboard/stock", {
	});
}

function getTopProduct() {
	return client.get("api/dashboard/top_five", {
	});
}

export default {
	getStatusSales,
	getTotalSales,
	getTotalPurchase,
	getSalesProduct,
	getResumeStock,
	getTopProduct,
	getSalesProductWeekly,
	getSalesPriceWeekly,
	getSalesRetailWeekly,
	getSalesRetailPriceWeekly,
}